(function () {
    'use strict';

    function initSection(section) {
      if (!section || !section.hasAttribute('data-hat-fits-section')) return;

      const swiperElement = section.querySelector('[data-hat-fits-swiper]');
      const prevButton = section.querySelector('[data-swiper-prev]');
      const nextButton = section.querySelector('[data-swiper-next]');
      const progressBar = section.querySelector('[data-progress-bar]');
      const progressBarFill = progressBar ? progressBar.querySelector('.hat-fits__progress-bar') : null;

      let swiperInstance = null;
      let wheelListenerAdded = false;
      let accumulatedWheelDelta = 0;
      let wheelRafId = null;
      let wheelSnapTimeout = null;

      function destroySwiper() {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }

      function initSwiper() {
        if (!swiperElement || typeof Swiper === 'undefined') {
          if (typeof Swiper === 'undefined') {
            setTimeout(initSwiper, 100);
          }
          return;
        }

        destroySwiper();

        const isMobile = window.innerWidth <= 767;
        const slidesPerView = isMobile ? 1 : 3.5;
        const spaceBetween = 8;

        swiperInstance = new Swiper(swiperElement, {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          loop: false,
          speed: 300,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          on: {
            init: function () {
              updateProgress(this);
              updateNavButtons(this);
              if (progressBar) setupProgressBarDrag(progressBar, this);
              if (!wheelListenerAdded && swiperElement) {
                wheelListenerAdded = true;
                swiperElement.addEventListener(
                  'wheel',
                  function (e) {
                    if (!swiperInstance || window.innerWidth <= 767) return;
                    const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
                    if (!isHorizontal) return;
                    const rawDelta = -e.deltaX;
                    const sensitivity = 12;
                    accumulatedWheelDelta += rawDelta * sensitivity;
                    if (Math.abs(accumulatedWheelDelta) < 0.5) return;
                    e.preventDefault();
                    if (wheelRafId == null) {
                      wheelRafId = requestAnimationFrame(function applyWheelFrame() {
                        wheelRafId = null;
                        if (!swiperInstance || Math.abs(accumulatedWheelDelta) < 0.5) return;
                        if (wheelSnapTimeout) clearTimeout(wheelSnapTimeout);
                        const swiperMin =
                          typeof swiperInstance.minTranslate === 'function' ? swiperInstance.minTranslate() : 0;
                        const swiperMax =
                          typeof swiperInstance.maxTranslate === 'function' ? swiperInstance.maxTranslate() : 0;
                        const minT = Math.min(swiperMin, swiperMax);
                        const maxT = Math.max(swiperMin, swiperMax);
                        const t =
                          typeof swiperInstance.getTranslate === 'function'
                            ? swiperInstance.getTranslate()
                            : swiperInstance.translate;
                        const delta = accumulatedWheelDelta;
                        accumulatedWheelDelta = 0;
                        let newT = t + delta;
                        newT = Math.max(minT, Math.min(maxT, newT));
                        const progress = maxT !== minT ? (newT - maxT) / (minT - maxT) : 0;
                        if (typeof swiperInstance.setTransition === 'function') swiperInstance.setTransition(0);
                        swiperInstance.setTranslate(newT);
                        if (typeof swiperInstance.setTransition === 'function') swiperInstance.setTransition(300);
                        updateProgress(swiperInstance, progress);
                        updateNavButtons(swiperInstance);
                        wheelSnapTimeout = setTimeout(function () {
                          wheelSnapTimeout = null;
                          if (!swiperInstance) return;
                          const count = swiperInstance.slides.length;
                          if (count <= 1) return;
                          const currentT =
                            typeof swiperInstance.getTranslate === 'function'
                              ? swiperInstance.getTranslate()
                              : swiperInstance.translate;
                          var swiperMin =
                            typeof swiperInstance.minTranslate === 'function' ? swiperInstance.minTranslate() : 0;
                          var swiperMax =
                            typeof swiperInstance.maxTranslate === 'function' ? swiperInstance.maxTranslate() : 0;
                          var endTranslate = Math.min(swiperMin, swiperMax);
                          var activeIndex = 0;
                          if (currentT <= endTranslate + 10) {
                            activeIndex = count - 1;
                          } else {
                            var bestDist = Infinity;
                            for (var i = 0; i < count; i++) {
                              var slideOffset = swiperInstance.slides[i].offsetLeft;
                              var targetT = -slideOffset;
                              var dist = Math.abs(currentT - targetT);
                              if (dist < bestDist) {
                                bestDist = dist;
                                activeIndex = i;
                              }
                            }
                          }
                          if (activeIndex === count - 1) {
                            if (typeof swiperInstance.setTransition === 'function') swiperInstance.setTransition(300);
                            swiperInstance.setTranslate(endTranslate);
                          } else {
                            swiperInstance.slideTo(activeIndex, 300);
                          }
                          updateProgress(swiperInstance);
                          updateNavButtons(swiperInstance);
                        }, 150);
                      });
                    }
                  },
                  { passive: false },
                );
              }
            },
            slideChange: function () {
              updateProgress(this);
              updateNavButtons(this);
            },
            slideChangeTransitionEnd: function () {
              updateProgress(this);
              updateNavButtons(this);
            },
            resize: function () {
              const newIsMobile = window.innerWidth <= 767;
              this.params.slidesPerView = newIsMobile ? 1 : 3.5;
              this.update();
              updateProgress(this);
              updateNavButtons(this);
            },
          },
        });
      }

      function updateProgress(swiper, progressOverride) {
        if (!progressBarFill || !swiper) return;

        const totalSlides = swiper.slides.length;
        let scrollRatio;

        if (progressOverride !== undefined) {
          scrollRatio = progressOverride;
        } else if (totalSlides <= 1) {
          scrollRatio = 0;
        } else {
          const minT = typeof swiper.minTranslate === 'function' ? swiper.minTranslate() : 0;
          const maxT = typeof swiper.maxTranslate === 'function' ? swiper.maxTranslate() : 0;
          const translate = typeof swiper.getTranslate === 'function' ? swiper.getTranslate() : swiper.translate;
          var startTranslate = Math.max(minT, maxT);
          var endTranslate = Math.min(minT, maxT);
          var range = endTranslate - startTranslate;
          scrollRatio = range !== 0 ? (translate - startTranslate) / range : 0;
          scrollRatio = Math.min(1, Math.max(0, scrollRatio));
          if (swiper.isBeginning) scrollRatio = 0;
          if (swiper.isEnd) scrollRatio = 1;
        }

        const progress = totalSlides > 1 ? ((scrollRatio * (totalSlides - 1) + 1) / totalSlides) * 100 : 0;

        progressBarFill.style.width = '';
        const thumbWidthPercent = 20;
        const maxLeft = 100 - thumbWidthPercent;
        const leftPct = scrollRatio * maxLeft;
        progressBarFill.style.left = leftPct + '%';
        progressBarFill.classList.toggle('hat-fits__progress-bar--empty', progress <= 0);
      }

      function updateNavButtons(swiper) {
        if (!swiper) return;
        if (prevButton) {
          prevButton.disabled = swiper.isBeginning;
        }
        if (nextButton) {
          nextButton.disabled = swiper.isEnd;
        }
      }

      function setupProgressBarDrag(progressBarEl, swiper) {
        if (!progressBarEl || !swiper) return;

        if (progressBarEl._progressDragSetup) {
          progressBarEl._progressSwiper = swiper;
          return;
        }
        progressBarEl._progressDragSetup = true;
        progressBarEl._progressSwiper = swiper;

        function getTotalSlides() {
          return progressBarEl._progressSwiper ? progressBarEl._progressSwiper.slides.length : 0;
        }

        function getProgress(clientX) {
          const rect = progressBarEl.getBoundingClientRect();
          const progress = (clientX - rect.left) / rect.width;
          return Math.min(1, Math.max(0, progress));
        }

        function goToProgress(clientX) {
          const total = getTotalSlides();
          if (total <= 1) return;
          const progress = getProgress(clientX);
          const slideIndex = Math.min(total - 1, Math.max(0, Math.round(progress * (total - 1))));
          var swiper = progressBarEl._progressSwiper;
          if (slideIndex === total - 1) {
            var minT = typeof swiper.minTranslate === 'function' ? swiper.minTranslate() : 0;
            var maxT = typeof swiper.maxTranslate === 'function' ? swiper.maxTranslate() : 0;
            var endT = Math.min(minT, maxT);
            if (typeof swiper.setTransition === 'function') swiper.setTransition(300);
            swiper.setTranslate(endT);
          } else {
            swiper.slideTo(slideIndex, 300);
          }
          updateProgress(swiper);
          updateNavButtons(swiper);
        }

        let activePointerId = null;

        function onPointerMove(e) {
          if (e.pointerType === 'touch') e.preventDefault();
          goToProgress(e.clientX);
        }

        function endDrag(e) {
          if (activePointerId !== null && e.pointerId !== activePointerId) return;
          activePointerId = null;
          progressBarEl.classList.remove('is-dragging');
          try {
            progressBarEl.releasePointerCapture(e.pointerId);
          } catch (err) {}
          progressBarEl.removeEventListener('pointermove', onPointerMove);
          progressBarEl.removeEventListener('pointerup', endDrag);
          progressBarEl.removeEventListener('pointercancel', endDrag);
          progressBarEl.removeEventListener('pointerleave', onPointerLeave);
        }

        function onPointerLeave(e) {
          if (activePointerId !== null && e.pointerId === activePointerId) endDrag(e);
        }

        progressBarEl.addEventListener(
          'pointerdown',
          function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (e.cancelable) e.preventDefault();
            activePointerId = e.pointerId;
            progressBarEl.classList.add('is-dragging');
            goToProgress(e.clientX);
            progressBarEl.setPointerCapture(e.pointerId);
            progressBarEl.addEventListener('pointermove', onPointerMove, { passive: false });
            progressBarEl.addEventListener('pointerup', endDrag);
            progressBarEl.addEventListener('pointercancel', endDrag);
            progressBarEl.addEventListener('pointerleave', onPointerLeave);
          },
          { passive: false },
        );
      }

      function notifySwymCollectionsLoaded() {
        document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
      }

      function initWishlistButtons() {
        const productCards = section.querySelectorAll('.hat-fits__card[data-product-handle]');
        if (!productCards.length) return;

        notifySwymCollectionsLoaded();
        setTimeout(notifySwymCollectionsLoaded, 1200);
      }

      section.addEventListener('click', function (clickEvent) {
        const wishlistButton = clickEvent.target.closest(
          '.hat-fits__card-wishlist, .swym-wishlist-collections-v2, .swym-wishlist-collections-v2-container',
        );
        const overlayTrigger = clickEvent.target.closest('[data-overlay-trigger]');
        const overlayClose = clickEvent.target.closest('[data-overlay-close]');

        if (wishlistButton) {
          clickEvent.stopPropagation();
        }

        if (overlayTrigger || overlayClose || wishlistButton) {
          return;
        }
      });

      function initOverlays() {
        const triggers = section.querySelectorAll('[data-overlay-trigger]');
        const overlays = section.querySelectorAll('[data-overlay]');
        const closeButtons = section.querySelectorAll('[data-overlay-close]');

        triggers.forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const overlayId = trigger.getAttribute('data-overlay-trigger');
            const overlay = document.getElementById('overlay-' + overlayId);
            if (overlay) {
              overlay.classList.add('active');
            }
          });
        });

        closeButtons.forEach(function (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const overlayId = closeBtn.getAttribute('data-overlay-close');
            const overlay = document.getElementById('overlay-' + overlayId);
            if (overlay) {
              overlay.classList.remove('active');
            }
          });
        });

        overlays.forEach(function (overlay) {
          overlay.addEventListener('click', function (e) {
            if (e.target === overlay) {
              overlay.classList.remove('active');
            }
          });
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            overlays.forEach(function (overlay) {
              if (overlay.classList.contains('active')) {
                overlay.classList.remove('active');
              }
            });
          }
        });
      }

      function applySegmentTracks() {
        const shapeFeaturesContainers = section.querySelectorAll('.hat-fits__shape-features');
        shapeFeaturesContainers.forEach(function (container) {
          const features = container.querySelectorAll('.hat-shape-feature');
          features.forEach(function (feature) {
            const track = feature.querySelector('.hat-shape-feature__slider-track');
            const indicator = feature.querySelector('.hat-shape-feature__slider-indicator');
            if (!track) return;
            const labels = feature.querySelectorAll('.hat-shape-feature__slider-label');
            const labelCount = labels.length;
            if (labelCount === 3) {
              var positionPct = 50;
              if (track.style.width) {
                var widthNum = parseFloat(track.style.width, 10);
                if (widthNum <= 33) positionPct = 16.667;
                else if (widthNum >= 67) positionPct = 83.333;
                else positionPct = 50;
              }
              track.style.width = '33.333%';
              track.style.left = positionPct + '%';
              track.style.transform = 'translateX(-50%)';
            } else if (labelCount === 2) {
              track.style.width = '50%';
              var centerPct = 25;
              if (indicator && indicator.style.left) {
                var indicatorLeft = parseFloat(indicator.style.left, 10);
                centerPct = indicatorLeft >= 50 ? 75 : 25;
              }
              track.style.left = centerPct + '%';
              track.style.transform = 'translateX(-50%)';
            }
          });
        });
      }

      initSwiper();
      initOverlays();
      initWishlistButtons();
      applySegmentTracks();
    }

    function initAll() {
      document.querySelectorAll('[data-hat-fits-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      const section = document.querySelector('[data-hat-fits-section][data-section-id="' + e.detail.sectionId + '"]');
      if (section) {
        initSection(section);
      }
    });
  })();
